import React from "react";

import * as Icons from "/component/base/Icon";
import Text from "/component/base/Text";
import { layout } from "/styles";
import { formatDate } from "/util/date";

import { ContentWrapper, TextContent, TitleContent } from "./ImmunizationListItem.styles";

interface Props {
  immunization: {
    title: string;
    dateString: string;
  };
}

const ImmunizationListItem = ({ immunization }: Props) => {
  const { title, dateString } = immunization;
  const docDate = formatDate(dateString, "MMMM dd, yyyy");

  return (
    <div
      css={[
        layout.flexCenterHorizontal,
        layout.margin("standard", "none"),
        layout.spacedChildrenHorizontal("standard"),
      ]}
    >
      <div>
        <Icons.Vaccine
          color="brandSecondary"
          background={{ size: 48, color: "brandSecondaryLight" }}
        />
      </div>
      <ContentWrapper>
        <TextContent>
          <TitleContent>
            <Text color={"textPrimary"} variant="body1Bold">
              {title}
            </Text>
          </TitleContent>

          <Text variant="body2" color="textSecondary">
            {docDate}
          </Text>
        </TextContent>
      </ContentWrapper>
    </div>
  );
};

export default ImmunizationListItem;
